import { UNREACHABLE_AFTER_MS } from "../../core/daemon-status.js";
import type { Daemon } from "./types.js";

type LiveStatus = Readonly<Record<string, "online" | "offline">>;

// When THIS client saw each daemon drop (online to offline): the redial proof isReconnecting reads.
export class DaemonDrops {
  private readonly at = new Map<string, number>();

  noteStatus(daemonId: string, status: "online" | "offline", wasOnline: boolean, now: number) {
    if (status === "online") this.at.delete(daemonId);
    else if (wasOnline) this.at.set(daemonId, now);
  }

  // A refetched row offline where the list had it online, with no live status: a drop. Returns `next`.
  noteRows(prev: readonly Daemon[], next: Daemon[], live: LiveStatus, now: number): Daemon[] {
    const wasOnline = (id: string) => prev.find((d) => d.id === id)?.status === "online";
    for (const d of next) {
      if (d.status !== "online" && wasOnline(d.id) && !live[d.id]) this.at.set(d.id, now);
    }
    return next;
  }

  within(daemonId: string, now: number): boolean {
    const dropped = this.at.get(daemonId);
    return dropped !== undefined && now - dropped >= 0 && now - dropped < UNREACHABLE_AFTER_MS;
  }

  clear(): void {
    this.at.clear();
  }
}
